import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { Card, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { Stream } from '@cloudflare/stream-react';
import staticData from '../staticData';
import { useParams } from 'react-router-dom';

const StyledTypography = styled(Typography)({
    fontWeight: 700,
    fontSize: '3rem',
    color: '#2c3e50',
    letterSpacing: '0.05em',
    margin: '0.5em 0',
    display: 'inline-block',
});

const Detail = () => {
    const { id } = useParams();

    const data = staticData.find((item) => item.id === id);

    return (
        <Box>
            <Grid container spacing={3}>
                <Grid item xs={12} textAlign={'center'}>
                    <StyledTypography>{data.title}</StyledTypography>
                </Grid>
                <Grid item xs={12} textAlign={'center'}>
                    <Card>
                        <Stream
                            controls
                            src={data.videoId}
                            autoplay={false}
                            muted={true}
                        />
                    </Card>
                </Grid>
            </Grid>
        </Box>
    );
};

export default Detail;
